export default class MainCtrl {
    constructor($scope, $rootScope, $state, $stateParams, $window, $location, $cookies, $timeout, $filter, EventListener, SweetAlert, Setting, Account, Rest, LateRequest, SideMenu, Events, TokenHandler, Notifications, Tag, Translate, HelpScout, PageMenu, User, CurrentAccount, AccessHandler, Subscriber) {
        this.helpScout = HelpScout;
        this.sideMenu = SideMenu;
        this.eventHandler = Events;
        this.eventListener = EventListener;
        this.pageMenu = PageMenu;
        this.settingsRepo = Setting;
        this.userRepo = User;
        this.tokenHandler = TokenHandler;
        this.accessHandler = AccessHandler;
        this.lateRequest = LateRequest;
        this.rest = Rest.rest;
        this.accountRepo = Account;
        this.currentAccount = CurrentAccount;
        this.notificationsRepo = Notifications;
        this.subscriber = Subscriber;

        this._filter = $filter;
        this._scope = $scope;
        this._rootScope = $rootScope;
        this._state = $state;
        this._window = $window;
        this._cookies = $cookies;
        this._location = $location;
        this._timeout = $timeout;

        this._scope.updateNotificationVisible = false;
        this.showNotice  = false;
        this.showMenu = false;
        this.showSettingsMenu = false;
        this.showCapacityLimits = false;
        this.requestCount = 0;

        this.sideMenu.init();
        this.currentAccount.init();
        this.eventListener.setScope(this._scope);
        this.eventListener.handleRootEvents();
        this.eventListener.handleScopedEvents();

        this.subscribersRecountDelay = 2000;
        this.hideSplash();

        this._scope.$on('event:signUp.show', () => this._scope.isSignUp = true);
        this._scope.$on('event:signUp.hide', () => {
            this._scope.isSignUp = false;
            this._state.go('dashboard.index');
        });

        this._scope.$on('event:externalLogin.show', () => {
            this._scope.loginRequired = true;
            this._scope.isExternalLogin = true;
        });
        this._scope.$on('event:externalLogin.hide', () => this._scope.isExternalLogin = false);

        this._scope.$on('event:auth.loginSucceeded', () => {
            // Make sure the user gets the appropriate account and permissions
            this._scope.loginRequired = false;
            this._scope.isExternalLogin = false;
            this.lateRequest.retryAll();
            this.rest.setDefaultHeaders({ 'Authorization': 'Bearer ' + this.tokenHandler.getToken() });
            this.requestCount = 0;
            this.notificationsRepo.listenToFanout(this._scope);
            this.showSplash();

            const redirectTo = $location.search().redirectTo;

            if (redirectTo) {
                window.location.href = redirectTo;
            } else {
                const accountInitListener = this._scope.$on('currentAccount:initialized', () => {
                    this.redirectToV5();
                    this.hideSplash();

                    accountInitListener();
                });
            }
        });

        this._scope.$on('event:auth.refresh', () => {
            if (this.requestCount < 1) {
                this.userRepo.refresh(this.tokenHandler.get()).then((response) => {
                    this.tokenHandler.set(response.token);
                    this.lateRequest.retryAll();
                    this.rest.setDefaultHeaders({ 'Authorization': 'Bearer ' + response.token });
                    this.requestCount = 0;
                    this.redirectToV5();
                });
            }

            this.requestCount++;
        });

        this._scope.$on('campaign:sentUpdate', () => {
            this.currentAccount.getRemainingSendCount();
        });

        this._scope.$on('subscriber:deleted', () => {
            this._timeout(() => {
                this.currentAccount.updateRemainingSubscriberCount();
            }, this.subscribersRecountDelay);
        });

        this._scope.notificationsCount = this._cookies.get('notificationsCount') || 0;

        this.notificationsRepo.initialize();
        this.notifications = this.notificationsRepo.notifications();

        this._scope.$on('notifications:changed', () => {
            this._scope.$apply();
        });

        $(document).on('click', '.issue-update-notification', () => {
            location.reload(true);
            this._scope.updateNotificationVisible = false;
        });

        this._scope.notificationsVisible = false;

        if (!this._scope.loginRequired) {
            this.notificationsRepo.listenToFanout(this._scope);
        }

        this.helpScout.initBeacon();

        if (this._location.search().action === 'log-out') {
            this.logout();
        }
    }

    reInitApp() {
        this._window.location.reload();
    }

    changeAccount() {
        if (this.activeAccount && this.activeAccount.name != this.currentAccount.name()) {
            this.userRepo.administrate(this.activeAccount.id).then(() => {
                this.eventHandler.flashEvent('notification', this._filter('translate')('ADMIN:FLASH:ACCOUNT_CHANGED'));
                this._rootScope.$broadcast('account:changed');
                this.reInitApp();
            });
        }
    }

    showSplash() {
        const splashEl = $('.loading-placeholder');

        splashEl.css('opacity', '1');
        splashEl.show();
    }

    hideSplash() {
        this._timeout(() => {
            const splashEl = $('.loading-placeholder');

            splashEl.animate({ 'opacity': '0' }, 300, () => {
                splashEl.hide();
            });
        }, 1500);
    }

    redirectToV5() {
        if (this.currentAccount) {
            const currentAccountData = this.currentAccount.data;

            if (currentAccountData) {
                const currentAccount = currentAccountData.account;

                if (currentAccount) {
                    const createdAt = currentAccount.created_at;
                    const isCreatedAtValid = createdAt && moment(createdAt, 'YYYY-MM-DD HH:mm:ss', true).isValid();

                    if (isCreatedAtValid) {
                        const createdAtMoment = moment(currentAccount.created_at)
                            .utc()
                            .startOf('day');
                        const redirectDateBenchmarkMoment = moment()
                            .utc()
                            .set('year', 2023)
                            .set('month', 1)
                            .date(8)
                            .startOf('day');

                        if (createdAtMoment.isAfter(redirectDateBenchmarkMoment, 'date') || !currentAccount.onboardingFinished) {
                            this.goTo('v5');
                        }
                    }
                }
            }
        }
    }

    goTo(state) {
        if (state == 'v5') {
            window.location.href = 'v5';
        } else if (state == 'setting') {
            this._state.go('setting.folder', { folder: 'sender' });
        } else if (state == 'imagebank') {
            this._scope.$broadcast('imageBank:toggle', true);
        } else if (state == 'docs') {
            window.open(this._filter('translate')('SIDEMENU:DOCS:LINK'), '_blank');
        } else {
            this._state.go(state + '.index')
        }

        this.menuShow = false;
        this.settingsMenuShow = false;
    };

    goToSubview(state) {
        this.pageMenu.route(state);
    };

    sideMenuItems() {
        return this.sideMenu.getItems();
    }

    dropDownMenu() {
        return this.sideMenu.getDropDownMenu();
    }

    sideMenuActive() {
        return this.sideMenu.getActive();
    }

    toggleMainMenu() {
        this.showMenu = !this.showMenu;
    }

    toggleSettingsMenu() {
        this.showSettingsMenu = !this.showSettingsMenu;
    }

    toggleCapacityLimits() {
        this.showCapacityLimits = !this.showCapacityLimits;
    }

    menuItems() {
        return this.pageMenu.getActive();
    }

    getEvents() {
        return this.eventHandler.getEvents();
    }

    hasEvents() {
        return this.eventHandler.hasEvents();
    }

    logout() {
        this.userRepo.logout().then((response) => {
            this.eventHandler.flashEvent('notification', this._filter('translate')('GLOBAL:LOGGED_OUT'));
            this.tokenHandler.remove();
            this.accessHandler.remove();
            this.helpScout.logOutFromBeacon();

            window.location.href = 'v5/#/auth/login';

            // commented this to avoid showing old login page and redirect to v5
            // this._scope.loginRequired = true;

            // this._scope.isExternalLogin = false;
        })
    };

    toggleNotifications() {
        this._scope.notificationsVisible = !this._scope.notificationsVisible;
        this._scope.notificationsCount = 0;
        this._cookies.remove('notificationsCount');
    };

    followNotificationLink(notification) {
        if (notification.link) {
            this._location.path(notification.link);
        } else if (notification.notification_type_id == 6 && notification.notification_method_id == 4) {
            // Hack for export without instigator
            this._window.open(notification.custom_data);
        }

        this.toggleNotifications();
    };

    stopImport(event, notification) {
        event.stopPropagation();
        this.subscriber.stopImport(notification.instigator.id);
    };

    closeBeacon() {
        this.helpScout.closeBeacon();
    }

    closeJourneyInfo() {
        this._window.localStorage.setItem('journey_info_closed_v4', true);
    }
}
